import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { S1MonthlyCommentsEditCard } from "./edit_card";
import { TechnicalInfoCard } from "@/components/TechnicalInfoCard";
import { Tables } from "@/gen/tableNames/tables";
import { Clients } from "@/lib/clients";

export const S1MonthlyCommentsCard = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <S1MonthlyCommentsEditCard id={Number(id)} />
        <TechnicalInfoCard
          id={Number(id)}
          client={Clients.S1_QUANTILIA}
          table_name={Tables.S1_MONTHLY_COMMENTS}
        />
        <AuditCard
          id={Number(id)}
          client={Clients.S1_QUANTILIA}
          audit_table_name={Tables.S1_MONTHLY_COMMENTS}
        />
      </div>
    </div>
  );
};
